import Banner from '@zenbusiness/zui/Banner';
import SharedAsset from '@zenbusiness/zui/SharedAsset';

import { CARD_STATUS } from '#client/constants/cards';
import { MODAL_NAMES } from '#client/constants/modals';
import useCardsContext from '#client/hooks/useCardsContext';
import useModalContext from '#client/hooks/useModalContext';
import {
  defaultPayloadBannerDisplayed,
  defaultPayloadButtonPressed
} from '#client/hooks/useTrackEvent';
import useUnitAccount from '#client/hooks/useUnitAccount';
import { BannerWrapperStyled } from '#client/pages/SharedStyles';

export default function FrozenCardBanner() {
  const { physicalCard, cardsLoading } = useCardsContext();
  const { loading: loadingUnitAccount } = useUnitAccount();
  const { openModal } = useModalContext();
  const isFrozenCard = physicalCard?.status === CARD_STATUS.FROZEN;

  if (cardsLoading || loadingUnitAccount) {
    return undefined;
  }

  return isFrozenCard ? (
    <BannerWrapperStyled>
      <Banner
        clickstreamProps={{
          bannerDisplayed: {
            ...defaultPayloadBannerDisplayed,
            bannerType: 'info',
            appPageName: 'active_banking_dashboard',
            elementName: 'debit_Card_frozen_banking'
          }
        }}
        slotProps={{
          primaryAction: {
            label: 'Unfreeze card',
            clickstreamProps: {
              ...defaultPayloadButtonPressed,
              elementName: 'unfreeze_card_from_banner',
              elementText: 'Unfreeze card',
              appPageName: 'active_banking_dashboard'
            },
            onClick: () => {
              openModal({
                name: MODAL_NAMES.UNFREEZE_CARD_MODAL,
                cardId: physicalCard?.id,
                last4Digits: physicalCard?.last4Digits
              });
            }
          }
        }}
        slots={{
          startIcon: (
            <SharedAsset
              alt=""
              src="/icon/micro/alert-fill.svg"
            />
          )
        }}
        subtitle="Recurring charges or swipes on this card cannot be processed until you unfreeze your card."
        title="Your card is frozen"
      />
    </BannerWrapperStyled>
  ) : null;
}
